import { NumberUtils } from '@spotify/confidence-core-react';

export interface Treatment {
  displayName?: string;
  name?: string;
  variant: string;
  weight: unknown;
}

export type RawMetric = Record<string, unknown>;

export interface ParsedMetric {
  metric: string;
  isGuardrail: boolean;
  direction?: string;
  mde?: number;
  nim?: number;
}

export const parseMetric = (raw: RawMetric): ParsedMetric => {
  const metric = String(raw.metric ?? raw.name ?? '');
  const role = (raw.metricRole ?? raw.metric_role ?? {}) as Record<
    string,
    unknown
  >;

  const metricKind = String(role.metricKind ?? role.metric_kind ?? '');
  const isGuardrail = metricKind === 'GUARDRAIL';

  const direction = String(
    raw.preferredDirection ?? raw.preferred_direction ?? '',
  );

  const rawMde = role.minimumDetectableEffect ?? role.minimum_detectable_effect;
  const mde =
    rawMde !== undefined && rawMde !== null ? Number(rawMde) : undefined;
  const rawNim = role.nonInferiorityMargin ?? role.non_inferiority_margin;
  const nim =
    rawNim !== undefined && rawNim !== null ? Number(rawNim) : undefined;

  return { metric, isGuardrail, direction, mde, nim };
};

export const formatMDE = (mde: number | undefined): string => {
  if (mde === undefined) return '';
  return `Detect changes ≥ ${NumberUtils.formatRatioAsPercentage(mde)}`;
};

export const getDirectionText = (
  direction: string | undefined,
  isGuardrail: boolean,
): string => {
  if (isGuardrail) {
    if (direction === 'INCREASE') return 'Must not decrease';
    if (direction === 'DECREASE') return 'Must not increase';
    return 'Must not change';
  }
  if (direction === 'INCREASE') return 'Should increase';
  if (direction === 'DECREASE') return 'Should decrease';
  return 'Any direction';
};
